export const projectsData = [
  {
    id: 1,
    title: "CodeWatchtower",
    date: "Oct - Dec 2022",
    techStack: "Next.js - Typescript - Sass",
    team: "Projet en groupe",
    doc: "https://www.notion.so/CodeWatchtower-38e5be3f06744e839f4fce738189e118",
    infos: `Le projet de réseaux social était un projet ambitieux que j'ai dirigé en tant que chef de projet. Nous avons travaillé en équipe pour créer un réseau social entièrement fonctionnel. Dans la partie front, nous avons décidé de faire un projet par personne. Deux développeurs ont travaillé sur la partie Back (qui n'est pas encore terminée).

      Bien que le projet ait connu des complications et que la plupart des membres de l'équipe ne soient pas restés jusqu'à la fin, j'ai appris de précieuses compétences en leadership et en gestion de projet.`,
    img: "./assets/img/code-watchtower.webp",
    webLink: "https://code-watchtower.vercel.app/",
    githubLink: "https://github.com/RudyDupuis/social-networks_project_front",
  },
  {
    id: 2,
    title: "Maquette MielsDupuis",
    date: "Oct - Dec 2022",
    techStack: "HTML - Sass - Javascript",
    team: "Projet en solo",
    doc: "",
    infos:
      "Ce projet est une maquette d'un site de vente de miel en ligne. Il a été développé avec un peu de JavaScript pour les animations. Le site a été conçu avec une approche visuellement attrayante et interactive. Bien que la partie back-end ne soit pas implémentée, ce projet m'a permis de m'améliorer en intégration de maquette.",
    img: "./assets/img/maquette-mielsdupuis.webp",
    webLink:
      "https://rudydupuis.github.io/maquette-mielsdupuis-en-html-sass-js/",
    githubLink:
      "https://github.com/RudyDupuis/maquette-mielsdupuis-en-html-sass-js",
  },
  {
    id: 3,
    title: "Stratège",
    date: "Dec 2022",
    techStack: "HTML - CSS - Javascript",
    team: "Projet en solo",
    doc: "",
    infos:
      "Ce projet est une réalisation d'un jeu de plateau que j'ai inventé il y a plusieurs années. Bien que ce ne soit pas mon domaine de compétence habituel, ce projet m'a permis de développer mes compétences sur la manipulation du DOM en Javascript.",
    img: "./assets/img/jeux-stratege.webp",
    webLink: "https://rudydupuis.github.io/Strategist/",
    githubLink: "https://github.com/RudyDupuis/Strategist",
  },
  {
    id: 4,
    title: "Mini-Projets",
    date: "Nov 2022 - Jan 2023",
    techStack: "HTML - CSS - Javascript",
    team: "Projet en solo",
    doc: "",
    infos:
      "Mini-Projets est un site qui regroupe une collection de projets développés en HTML, CSS et JavaScript. Ce site couvre une variété de projets allant de mini-jeux tels que Pong à l'intégration d'API et la création de formulaires. Ce projet m'a permit de tester et d'apprendre une grande partie des fonctionnalités du languages Javascript.",
    img: "./assets/img/mini-projets.webp",
    webLink: "https://rudydupuis.github.io/Mini_projets",
    githubLink: "https://github.com/RudyDupuis/Mini_projets",
  },
];
